import React from 'react';
import { Gallery } from 'react-photoswipe-gallery';
import ImageBlock from './ImageBlock';
import 'photoswipe/dist/photoswipe.css';

const PortfolioBody = ({ portfolioContent }) => {
const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";

  return (
    <section onContextMenu={(e) => e.preventDefault()}>
      <div className="container">
        <div className="row g-3 g-xl-5 gallery-1">
          <Gallery>
            {portfolioContent &&
              portfolioContent.map((block, i) => {
                const colSize = block.Columns?.replace('C', '') || '12';
                const bgColor = (block.BackgroundColor || 'light').toLowerCase();

                switch (block.__component) {
                  case 'content.quote':
                    return (
                      <div className={`col-lg-${colSize}`} key={i}>
                        <div className={`card h-100 bg-${bgColor}`}>
                          <div className="card-wrap p-xl-5">
                            <div className="card-header pb-0">
                              <h4 className="card-title fs-4 text-black">{block.Text}</h4>
                            </div>
                            <div className="card-footer pt-0 mt-auto">
                              <p
                                className="text-secondary"
                                style={{ textTransform: 'uppercase' }}
                              >
                                {block.Author}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );

                  case 'content.image':
                    return (
                      <ImageBlock
                        key={i}
                        block={block}
                        colSize={colSize}
                        STRAPI_URL={STRAPI_URL}
                      />
                    );

                  case 'content.text':
                    return (
                      <div key={i} className={`col-12 col-lg-${colSize}`}>
                        <p className="lead display-6 text-dark">{block.Text}</p>
                      </div>
                    );

                  default:
                    return null;
                }
              })}
          </Gallery>
        </div>
      </div>
    </section>
  );
};

export default PortfolioBody;
